export const translations = {
  GE: {
    home: "მთავარი",
    about: "ჩვენს შესახებ",
    product: "პროდუქტები",
    contact: "კონტაქტი",
    lang: "ენა",
  },
  EN: {
    home: "HOME",
    about: "ABOUT US",
    product: "PRODUCTS",
    contact: "CONTACT",
    lang: "LANGUAGE",
  },
  RU: {
    home: "ГЛАВНЫЙ",
    about: "О НАС",
    product: "ПРОДУКТЫ",
    contact: "КОНТАКТ",
    lang: "ЯЗЫК",
  }
};